import {useUserStore} from "../../store/userStore";
import {useAutoCreateRoom} from "../../hooks/VoiceLab";
import {useState} from "react";

const LabLandingPage = ()=> {
  const userId = useUserStore((state) => state.userId);
  const [selectedLanguage] = useState('zul');

  const { loading } = useAutoCreateRoom({
    userId,
    selectedLanguage,
  });

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-md px-4 lg:px-8 py-4">
        <div className="max-w-7xl mx-auto">
          <img
            src="/img/logo.png"
            alt="Vulavula Co-Pilot Logo"
            className="h-16 lg:h-20 w-auto object-contain"
          />
        </div>
      </header>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center p-4">
        <div className="text-center space-y-6 max-w-md">
          <div className="animate-pulse text-6xl">🎙️</div>
          <h2 className="text-2xl font-bold text-gray-900">
            Preparing your Voice Lab…
          </h2>
          {loading && (
            <div className="flex items-center justify-center gap-3">
              <div className="w-6 h-6 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-gray-600">
                Creating room and connecting
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LabLandingPage;